import { apiPost, apiGet } from './apiClient.js';

/**
 * Admin Integration Sync Service
 * For triggering and viewing integration sync runs
 */

/**
 * Trigger a sync run for an integration
 * @param {string} code - Integration code
 * @param {string} reason - Optional reason for sync
 * @param {number} intentAuditEventId - Intent audit event ID (required)
 */
export async function triggerSync(code, reason, intentAuditEventId) {
  if (!intentAuditEventId) {
    throw new Error('Intent audit event ID is required');
  }

  const body = {
    intentAuditEventId,
  };
  if (reason) {
    body.reason = reason.trim();
  }

  return apiPost(`/admin/integrations/${code}/sync`, body);
}

/**
 * List sync runs for an integration
 * @param {string} code - Integration code
 * @param {number} limit - Max number of runs to return (default 50)
 */
export async function listSyncRuns(code, limit = 50) {
  return apiGet(`/admin/integrations/${code}/sync-runs?limit=${limit}`);
}

